import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { UserTemplate } from "../models/UserTemplate";
import { UserTemplateSchema } from "../models/UserTemplateSchema";
import { UserTempQuerySend } from "../models/UserTempQuerySend";
import { UserTempDataResponse } from "../models/UserTempDataResponse";
import { HeaderUserTemplate } from "../models/HeaderUserTemplate";

export class UserTemplateService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_USERS_API}/user-templates`;
  }

  async addUserTemplate(
    userTemplate: UserTemplate
  ): Promise<Response<string | void>> {
    return (await axios.post(this.baseUrl, userTemplate)).data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameUserTemp: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async getUserTempSchemaByGroups(
    groups: string[]
  ): Promise<Response<UserTemplateSchema>> {
    const serviceURL = `${this.baseUrl}/schema`;
    const response = await axios.get(serviceURL, { params: { groups } });
    return response.data;
  }

  async getUserTempSchemaById(
    id: string
  ): Promise<Response<UserTemplateSchema>> {
    const serviceURL = `${this.baseUrl}/schema/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async checkIfExistByGroupInfo(id: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-group`;

    const params = {
      params: {
        idGroup: id
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async getUserTempByFilters(
    query: UserTempQuerySend
  ): Promise<Response<UserTempDataResponse>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getUserTempsByIdsArray(
    query: UserTempQuerySend
  ): Promise<Response<Array<HeaderUserTemplate>>> {
    const serviceURL = `${this.baseUrl}/by-array`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async updateStateUserTempById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async updateUserTemplate(
    id: string,
    userTemplate: UserTemplate
  ): Promise<Response<string | void>> {
    return (await axios.put(`${this.baseUrl}/${id}`, userTemplate)).data;
  }

  async getUserTemplateInfo(
    id: string
  ): Promise<Response<UserTemplate | void>> {
    return (await axios.get(`${this.baseUrl}/data/${id}`)).data;
  }

  async deleteUserTemp(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async getAllActiveUserTemplates(): Promise<Response<HeaderUserTemplate[]>> {
    const serviceURL = `${this.baseUrl}/get-active-user-templates`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
